import { SidebarContextType } from '@/interfaces';
import { FC, useState, createContext, useEffect } from 'react';

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SidebarContext = createContext<SidebarContextType>({} as SidebarContextType);

export const SidebarProvider: FC = ({ children }) => {
  const [sidebarToggle, setSidebarToggle] = useState(false);
  const [isCollapsed, setIsCollapsed] = useState(() => {
    const saved = localStorage.getItem('sidebarCollapsed');
    return saved === 'true';
  });
  
  const toggleSidebar = () => {
    setSidebarToggle(!sidebarToggle);
  };
  
  const closeSidebar = () => {
    setSidebarToggle(false);
  };

  const toggleCollapse = () => {
    setIsCollapsed((prev) => {
      const newValue = !prev;
      localStorage.setItem('sidebarCollapsed', String(newValue));
      return newValue;
    });
  };

  return (
    <SidebarContext.Provider value={{ sidebarToggle, toggleSidebar, closeSidebar, isCollapsed, toggleCollapse }}>
      {children}
    </SidebarContext.Provider>
  );
};
